import React, { useState, useEffect } from "react";
import author2 from "../../../Assets/img/authors/author3.webp";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinearProgress from "@mui/material/LinearProgress";

const ContentLocking = ({ id }) => {
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [comments, setComments] = useState([]);

    const [rating, setRating] = useState(0);
    const [overAllRating, setOverAllRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [rated, setRated] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    const [liked, setLiked] = useState(false);
    const [likeCount, setLikeCount] = useState(0);
    const [loadinglike, setLoadingLike] = useState(false);
    // const [showLikeMessage, setShowLikeMessage] = useState(false);
    // const [articleStatistics, setArticleStatistics] = useState();
    const link = window.location.href;

    // const [successMessage, setSuccessMessage] = useState("");

    // Handle click event for like and unlike
    const handleLikeClick = async () => {
        setLoadingLike(true);

        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "addLike",
                fk_ac_key: id,
                fk_user_key: sessionStorage.getItem("pk_user_key"),
                created_by: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;

            if (output == 1) {
                // // setLikeCount(response.data.likeCount);
                // setLiked(action === "like");
                // // localStorage.setItem(`liked`, action === "like" ? "true" : "false");
                // setShowLikeMessage(true);
                // setTimeout(() => setShowLikeMessage(false), 3000);

                getArticleStatistics(id);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoadingLike(false);
        }

        // axios
        //     .post("http://localhost/GBackendReact/like_post.php", { action }, { headers: { "Content-Type": "application/json" } })
        //     .then((response) => {
        //         if (response.data.likeCount !== undefined) {
        //             setLikeCount(response.data.likeCount);
        //             setLiked(action === "like");
        //             localStorage.setItem(`liked`, action === "like" ? "true" : "false");
        //             setShowLikeMessage(true);
        //             setLoadingLike(false);

        //             setTimeout(() => setShowLikeMessage(false), 3000);
        //         }
        //     })
        //     .catch((error) => {
        //         console.error(`Error ${action === "like" ? "liking" : "disliking"} the post:`, error);
        //     });
    };

    const handleClick = async (newRating) => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "addRating",
                rating: newRating,
                fk_ac_key: id,
                fk_user_key: sessionStorage.getItem("pk_user_key"),
                created_by: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;

            if (output == 1) {
                setShowMessage(true);
                setTimeout(() => setShowMessage(false), 6000);
                getArticleStatistics(id);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoadingLike(false);
        }
    };

    useEffect(() => {
        getAllCommentsByArticle(id);
        getArticleStatistics(id);
    }, [id]);

    const getAllCommentsByArticle = async (id) => {
        try {
            setLoading(true);

            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllCommentsByArticle",
                fk_ac_key: id,
            });

            const output = response.data;

            if (output.length > 0) {
                setComments(output);
            }
        } catch (error) {
            console.log("error" + error);
        } finally {
            setLoading(false);
        }
    };

    const getArticleStatistics = async (id) => {
        setLoading(true);

        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getArticleStatistics",
            pk_ac_key: id,
            fk_user_key: sessionStorage.getItem("pk_user_key"),
        });

        const output = response.data;

        if (Object.keys(output).length > 0) {
            const allUserState = output.allUserState;
            const curUserState = output.curUserState;
            setLiked(curUserState.cur_user_like == 1);
            setLikeCount(allUserState.total_user_like);
            const currentRate =
                typeof curUserState?.cur_user_rate === "number"
                    ? curUserState.cur_user_rate.toFixed(1)
                    : parseFloat(curUserState.cur_user_rate || 0).toFixed(1);

            const overallRate =
                typeof allUserState?.total_user_rate === "number"
                    ? allUserState.total_user_rate.toFixed(1)
                    : parseFloat(allUserState.total_user_rate || 0).toFixed(1);

            // Update the ratings
            setRating(currentRate);
            setOverAllRating(overallRate);

            // setRating(Math.round(curUserState.cur_user_rate));
            // setOverAllRating(Math.round(allUserState.total_user_rate));
            setRated(true);
        }
        setLoading(false);
    };

    const getTimeDifference = (row) => {
        const { MinuteDifference, HourDifference, DayDifference } = row;

        if (MinuteDifference < 60) {
            return `(${MinuteDifference} minute${MinuteDifference === 1 ? "" : "s"} ago)`;
        }

        if (HourDifference < 24) {
            return `(${HourDifference} hour${HourDifference === 1 ? "" : "s"} ago)`;
        }

        const days = Math.floor(HourDifference / 24);
        return `(${days > 0 ? days : DayDifference} day${(days > 0 ? days : DayDifference) === 1 ? "" : "s"} ago)`;
    };

    const formik = useFormik({
        initialValues: {
            fk_ac_key: id,
            comment: "",
            com_name: sessionStorage.getItem("full_name"),
            created_by: "",
            // email: "",
            // website: "",
        },
        validationSchema: Yup.object({
            comment: Yup.string()
                .required("Comment is required")
                .min(10, "Comment must be at least 10 characters long")
                .max(300, "Comment must be at most 300 characters.")
                .matches(/^[^\s].*[^\s]$/, "No leading or trailing spaces are allowed."),
            com_name: Yup.string()
                .required("Name is required")
                .matches(/^[a-zA-Z][a-zA-Z\s]*[a-zA-Z]$/, "Name should only contain letters and spaces, and should not start or end with a space.")
                .min(2, "Name must be at least 2 characters long")
                .max(100, "Name must be at most 100 characters."),

            // email: Yup.string().email("Invalid email address").required("Email is required"),
            // website: Yup.string().url("Invalid URL").required("Website is required"),
        }),
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            try {
                toast.dismiss();

                setIsSubmitting(true);

                const response = await axios.post(
                    BASE_URL + "API/apicall",
                    {
                        security_key: security_key,
                        mode: "addComment",
                        ...formValues,
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                const output = response.data;
                if (output == 1) {
                    resetForm();
                    getAllCommentsByArticle(id);
                    // setSuccessMessage("Posted successfully!");
                    // setTimeout(() => {
                    //     setSuccessMessage("");
                    // }, 3000);
                    toast.success("Posted successfully!", {
                        autoClose: 3000,
                    });
                } else {
                    throw new Error("Oops! Something went wrong.");
                }
            } catch (error) {
                console.error("Error during form reset or fetching comments:", error);
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            } finally {
                setTimeout(function () {
                    setIsSubmitting(false);
                }, 3000);
            }
        },
    });

    const { values, handleChange, handleBlur, touched, errors, handleSubmit, setFieldValue, resetForm, setValues } = formik;

    return (
        <>
            <ToastContainer position="top-center" containerId="containerA" />

            <div className="single-social-share clearfix wow fadeIn animated">
                <div className="entry-meta d-flex meta-1 font-small color-grey float-left mt-10">
                    <div className="hit-count mr-15">
                        <i className="ti-comment mr-5"></i>
                        {comments.length} comments
                    </div>

                    <div className="article-like-user mb-5 me-3">
                        <div className="like-button" onClick={handleLikeClick} style={{ cursor: "pointer" }}>
                            {loadinglike ? (
                                <div className="loader"></div> // Loader element
                            ) : liked ? (
                                <div>
                                    <span className="px-3 py-2 bg-light">
                                        <i className="fa-solid fa-heart f-22 text-danger"></i>
                                    </span>
                                    <span className="mt-2 ms-2 px-3 py-2 bg-light rounded-2">
                                        {likeCount} {likeCount === 1 ? "" : ""}
                                    </span>
                                </div>
                            ) : (
                                <>
                                    <span className="px-2 py-2">
                                        <i className="fa-regular fa-heart f-22"></i>
                                    </span>
                                    <span className="mt-2 py-2 ">
                                        {likeCount} {likeCount === 1 ? "" : ""}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Ratings */}
                    <div className="d-flex flex-column align-items-center justify-content-center me-3">
                        <p className="mb-0" style={{ marginTop: "-5px" }}>
                            {[1, 2, 3, 4, 5].map((starValue) => (
                                <i
                                    key={starValue}
                                    className={`fa-regular fa-star f-26 ${
                                        hover >= starValue || (rated && rating >= starValue) ? "fa-solid fa-star text-warning" : ""
                                    }`}
                                    // onClick={() => !rated && handleClick(starValue)}
                                    onClick={() => handleClick(starValue)}
                                    onMouseEnter={() => setHover(starValue)}
                                    onMouseLeave={() => setHover(0)}
                                    style={{ cursor: "pointer" }}
                                ></i>
                            ))}
                        </p>
                        {showMessage && <p className="text-center text-success mb-0">Thank you for rating this Article!</p>}
                        <p className="text-center">Your rating: {rating}/5.</p>
                    </div>

                    {/* Overall Ratings */}
                    {/* <div className="d-flex flex-column align-items-center justify-content-center">
                        <p className="mb-0" style={{ marginTop: "-5px" }}>
                            {[1, 2, 3, 4, 5].map((starValue) => (
                                <i
                                    key={starValue}
                                    className={`fa-regular fa-star f-26 ${rated && overAllRating >= starValue ? "fa-solid fa-star text-primary" : ""}`}
                                ></i>
                            ))}
                        </p>
                        <p className="text-center">Overall rating: {overAllRating}/5.</p>
                    </div> */}
                </div>
                <ul className="d-inline-block list-inline float-md-right mt-md-0 mt-4">
                    <li className="list-inline-item">
                        <a
                            className="social-icon facebook-icon text-xs-center "
                            target="_blank"
                            href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`}
                        >
                            <i className="ti-facebook"></i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a
                            className="social-icon twitter-icon text-xs-center"
                            target="_blank"
                            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}`}
                        >
                            <i className="ti-twitter-alt"></i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a
                            className="social-icon pinterest-icon text-xs-center"
                            target="_blank"
                            href={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(link)}`}
                        >
                            <i className="ti-pinterest"></i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a
                            className="social-icon instagram-icon text-xs-center"
                            target="_blank"
                            href={`https://instagram.com/?url=${encodeURIComponent(link)}`}
                        >
                            <i className="ti-instagram"></i>
                        </a>
                    </li>
                </ul>
            </div>
            <div className="bt-1 border-color-1 mt-30 mb-30"></div>

            <div className="single-more-articles">
                <h6 className="widget-title mb-30 font-weight-bold text">You might be interested in</h6>
                <div className="post-block-list post-module-1 post-module-5">
                    <ul className="list-post">
                        <li className="mb-15">
                            <div className="d-flex">
                                <div className="post-thumb post-thumb-80 d-flex mr-15 border-radius-5 img-hover-scale">
                                    <a className="color-white" href="#">
                                        <img src="https://newsboard-html.netlify.app/demo/assets/imgs/authors/author-1.jpg" alt="" />
                                    </a>
                                </div>
                                <div className="post-content media-body">
                                    <h6 className="post-title mb-10 text-limit-2-row">
                                        <a href="#">America's Governors Get Tested for a Virus That Is Testing Them</a>
                                    </h6>
                                    <div className="entry-meta meta-1 font-x-small color-grey">
                                        <span className="post-on">25 Jun</span>
                                        <span className="hit-count has-dot">126k Views</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="d-flex">
                                <div className="post-thumb post-thumb-80 d-flex mr-15 border-radius-5 img-hover-scale">
                                    <a className="color-white" href="#">
                                        <img src="https://newsboard-html.netlify.app/demo/assets/imgs/authors/author-2.jpg" alt="" />
                                    </a>
                                </div>
                                <div className="post-content media-body">
                                    <h6 className="post-title mb-10 text-limit-2-row">
                                        <a href="#">Bartering Child’s Dress for Food: Life in Lebanon’s Economic Crisis</a>
                                    </h6>
                                    <div className="entry-meta meta-1 font-x-small color-grey mt-10">
                                        <span className="post-on">25 April</span>
                                        <span className="hit-count has-dot">37k Views</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            {/* {comments.length > 0 && (
                <div className="comments-area">
                    <h3 className="mb-30">{comments.length > 0 && String(comments.length).padStart(2, "0")} Comments</h3>

                    {comments.length == 0 && <h4 className="text-center mt-5">Comments not available</h4>}

                    {comments.length > 0 &&
                        comments.map((row) => (
                            <div key={row.pk_com_key} className="comment-list wow fadeIn animated">
                                <div className="single-comment justify-content-between d-flex">
                                    <div className="user justify-content-between d-flex">
                                        <div className="thumb">
                                            <img src="https://newsboard-html.netlify.app/demo/assets/imgs/authors/author-1.jpg" alt="" />
                                        </div>
                                        <div className="desc">
                                            <p className="comment">{row.comment}</p>
                                            <div className="d-flex justify-content-between">
                                                <div className="d-flex align-items-center">
                                                    <h5>
                                                        <span>{row.com_name}</span>
                                                    </h5>
                                                    <p className="date">{getTimeDifference(row)}</p>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            )} */}

            {/* <div className="comment-form wow fadeIn animated">
                <h3 className="mb-30">Leave a Reply</h3>

                <Form className="form-contact comment_form" onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <Form.Control
                                    as="textarea"
                                    className="form-control w-100"
                                    name="comment"
                                    id="comment"
                                    cols="30"
                                    rows="9"
                                    placeholder="Write Comment"
                                    value={values.comment}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.comment && touched.comment && <p className="text-danger">{errors.comment}</p>}
                               
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <Form.Control
                                    className="form-control"
                                    name="com_name"
                                    id="com_name"
                                    type="text"
                                    placeholder="Name"
                                    value={values.com_name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    readOnly
                                />
                                {errors.com_name && touched.com_name && <p className="text-danger">{errors.com_name}</p>}
                            </div>
                        </div>
                      
                    </div>
                    <div className="form-group">
                        <Button type="submit" className="btn btn-dark" disabled={isSubmitting}>
                            Post Comment
                            {isSubmitting && <LinearProgress />}
                        </Button>
                    </div>
                </Form>
            </div> */}
            <style jsx>
                {`
         .loader {
          display: inline-block;
          width: 15px;
          height: 15px;
          border: 3px solid #000;
          border-radius: 50%;
          border-top: 3px solid #fff;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        `}
            </style>
        </>
    );
};

export default ContentLocking;
